// (2026-05-23) Cliente del endpoint publico GET /api/config/public.
// La tabla `configuracion` del backend expone parametros editables (marca,
// duracion del splash, URLs publicas, plantillas) sin necesidad de
// redeploy. Las filas marcadas `publico=true` salen por este endpoint
// sin JWT. Cachea en memoria modulo-singleton: un solo fetch por carga
// de SPA es suficiente.
import api from "./axiosConfig";

let _cache = null;
let _promise = null;

/**
 * Devuelve un dict {clave: valor} de la tabla configuracion donde
 * publico=true. Falla suave si el endpoint no responde (devuelve {}) —
 * los consumidores deben tener defaults locales.
 */
export const getPublicConfig = async () => {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = (async () => {
    try {
      const res = await api.get("/api/config/public");
      _cache = (res && res.data) || {};
      return _cache;
    } catch (e) {
      console.warn("getPublicConfig: no se pudo leer /api/config/public", e);
      return {};
    } finally {
      _promise = null;
    }
  })();
  return _promise;
};

/**
 * Invalida el cache. Util si en el admin se editan valores y queremos
 * que el siguiente getPublicConfig haga refetch.
 */
export const clearPublicConfigCache = () => {
  _cache = null;
};
